import { render, staticRenderFns } from "./WebRtcLivestreamForm.vue?vue&type=template&id=53882260&scoped=true"
import script from "./WebRtcLivestreamForm.vue?vue&type=script&lang=js"
export * from "./WebRtcLivestreamForm.vue?vue&type=script&lang=js"
import style0 from "./WebRtcLivestreamForm.vue?vue&type=style&index=0&id=53882260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53882260",
  null
  
)

export default component.exports